import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Select from '../../../form/component/Select'

const CC_REASONS = [
    {
        id:'notGoOnBJ',
        value: 'NOT GO ON & REFINEMENT both jaws - Not tracking well, customer service will call you'
    },
    {
        id:'notGoOnUJ',
        value: 'NOT GO ON & REFINEMENT UJ - Not tracking well, customer service will call you'
    },
    {
        id:'notGoOnLJ',
        value: 'NOT GO ON & REFINEMENT LJ - Not tracking well, customer service will call you'
    },
    {
        id:'notGoOnGeneral',
        value: 'NOT GO ON & General Problem (no refinement, don\'t change aligners, please SPECIFY IN COMMENT)'
    },  
    {
        id: 'badFeedbackScore',
        value: 'Bad Feedback Score - Contact patient'
    },
]

const AlignerCustomerCommunicationCommentWidget = ({ customer, saveTreatmentExecutionClarificationComment, changeTreatmentExecutionList }) => {

    const treatmentExecutionList = customer.treatmentExecutionList

    if (treatmentExecutionList.length === 0) {
        return null
    }

    const alignerCheckins = treatmentExecutionList[treatmentExecutionList.length - 1].alignerCheckInList
    const clarificationComment = alignerCheckins[alignerCheckins.length - 1].clarificationComment

    return (
        <ContentBox title="Choose reason">
            <Select
                object={{ clarificationComment }}
                name="clarificationComment"
                valueList={CC_REASONS}
                addEmpty={true}
                onChange={(name, value) => {
                    saveTreatmentExecutionClarificationComment(value)
                }}
            />
        </ContentBox>
    )
}

AlignerCustomerCommunicationCommentWidget.propTypes = {
    customer: PropTypes.object.isRequired,
    saveTreatmentExecutionClarificationComment: PropTypes.func.isRequired,
}

export default AlignerCustomerCommunicationCommentWidget



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/AlignerCustomerCommunicationCommentWidget.js